
export const ENDPOINT = 'https://ms.biomed.cas.cz/msb-backend/public/rest/';
export const URL_PREFIX = '';
export const DECIMAL_PLACES = 6;
export const SHOW_ID = false;
export const CHEMSPIDER_ONE_KEY : string = '';
